import { RolesAndPrivilegesControllerApi } from "../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useRoleStatusChange = () =>
  useMutationWithLoading(async (params: { roleId: number; status: boolean }) =>
    new RolesAndPrivilegesControllerApi(
      getConfigObject()
    ).updateRoleStatus(params?.roleId, params?.status, getXtenantId())
  );
